import React from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { reduxForm, getFormValues, change } from 'redux-form';
import { useNavigate } from 'react-router-dom';
import Logger from '../../../util/Logger';
import * as jobActions from '../../../actions/jobActions';
import TreatmentResultsForm from '../../../components/jobs/treatmentResults/TreatmentResultsForm';
import { treatmentResultsForm } from '../../../constants/FormConstants';
import TreatmentTypeIds from '../../../constants/TreatmentTypeIds';
import {
  isExportOther,
  isImportAndHeatTreatment,
  isImportOtherTypeID,
} from '../../../util/JobTypeHelper';
import { bindActionCreators } from 'redux';

const calculateEndDate = (treatmentResults, currentJob) => {
  const formValues = getFormValues(treatmentResultsForm)(currentJob);
  const currentEndDate = formValues&&formValues.endDate?formValues.endDate:null;
  return treatmentResults?treatmentResults.endDate :currentEndDate? currentEndDate : null;
};

const TreatmentResultsFormContainer = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Destructure state once, avoid multiple calls to useSelector
  const { currentJob, referenceData } = useSelector((state) => ({
    currentJob: state.currentJob,
    referenceData: state.referenceData,
  }));

  const { technicians } = referenceData;
  const { treatmentResults, treatmentDetails } = currentJob;
  const { treatmentTypeId } = treatmentDetails;
  const currentState = currentJob.currentState;

  const handleSubmit = props.onSubmit;

  // Calculate endDate and other variables
  const endDate = currentState === 'assigned' ? null : calculateEndDate(treatmentResults, currentJob);
  const markings = currentJob.treatmentTypeDetails.markings || [];
  const mbBottles = treatmentResults? treatmentResults.mbBottles : [];


  const validate = (values) => {
    const { numberOfSachets, actualTemperature, treatmentTypeId, jobTypeId } = values;
    const errors = {};
    
    if (treatmentTypeId === TreatmentTypeIds.MethylBromide && !isExportOther({ id: jobTypeId })) {
      if (!numberOfSachets || numberOfSachets === '0') {
        errors.numberOfSachets = 'Required';
      }
      if (!isImportOtherTypeID(jobTypeId) && !actualTemperature) {
        errors.actualTemperature = 'Required';
      }
    }
    return errors;
  };

  const onSubmitFail = (errors, dispatch, submitError) => {
    Logger.error(
      'Unable to save changes, please review the fields in red and try again.',
      submitError,
      errors,
      'Treatment Details not saved',
    );
  };

  // Get form values
  const formValues = useSelector((state) => getFormValues(treatmentResultsForm)(state));
  
  const actions = bindActionCreators({ changeFieldValue: change }, dispatch);

  return (
    <TreatmentResultsForm
      {...props}
      //initialValues={initialValues}
      clientsVolume={formValues?formValues.clientsVolume : null}
      mbTopUp={formValues.mbTopUp || null}
      technicians={technicians}
      formValues={formValues}
      validate={validate}
      onSubmitFail={onSubmitFail}
      actions={actions}
      currentJob={currentJob}
      onSubmit={handleSubmit}
    />
  );
};

// Optimized mapStateToProps
   // treatmentDetails   = currentJob.treatmentDetails;
   // treatmentResults = currentJob.treatmentResults;
const mapStateToProps = (state, props) => {
 const  currentJob  = state.currentJob;
 const  treatmentResults  = props.currentJob.treatmentResults;
 const treatmentDetails = props.currentJob.treatmentDetails
 const startDate = treatmentResults&&treatmentResults.startDate?treatmentResults.startDate:null;
  const { technicians } = state.referenceData;
  const { treatmentTypeId } = props.currentJob.treatmentDetails.treatmentTypeId;


  const existingTreatmentResults = {
    ...treatmentResults,
    startDate,
    treatmentTypeId,
    jobId: currentJob.id,
    jobTypeId: currentJob.typeId,
    endDate:treatmentResults&&treatmentResults.endDate?treatmentResults.endDate:null,
    markings:treatmentResults&&treatmentResults.markings?treatmentResults.markings:null,
    mbBottles:treatmentResults&&treatmentResults.mbBottles?treatmentResults.mbBottles:null,
    stockLocation:treatmentResults&&treatmentResults.stockLocation?treatmentResults.stockLocation:null,
  };

  const defaultInitialValues = {
    jobId: currentJob.id,
    jobTypeId: currentJob.typeId,
    startDate: null,
    treatmentTypeId,
    endDate:null,
    fumigatingTechnicianId: isImportAndHeatTreatment({ id: currentJob.typeId }) ? currentJob.technicianId : null,
    markings:null,
    mbBottles:null,
  };

  //const { currentJob } = state;
 
  /*const initialValues = {
    ...(props.initialValues || {}),
    id: props.initialValues.id,
    jobId: currentJob.id,
    jobType: currentJob.type,
    treatmentResults:treatmentResults,
    //startDate:treatmentResults&&treatmentResults.startDate?treatmentResults.startDate:null,
    clientsVolume:treatmentResults&&treatmentResults.clientsVolume?treatmentResults.clientsVolume:null,
    treatmentDetails:treatmentDetails,
    markings: currentJob.treatmentTypeDetails.markings || [], // Fallback to empty array if no markings
  };*/
  var initialValues = treatmentResults ? existingTreatmentResults : defaultInitialValues;
  initialValues ={...initialValues, markings:currentJob.treatmentTypeDetails.markings || []}

  return { initialValues };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: treatmentResultsForm,
    enableReinitialize: true,
  })(TreatmentResultsFormContainer)
);
